export default __webpack_public_path__ + "static/media/opening-traps.199e59a1.txt";